import ClearIcon from '@mui/icons-material/Clear'
import SaveIcon from '@mui/icons-material/Save'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'

import CircularLoading from '../../../components/CircularProgress'
import SelectSearch, { IOptionSelect } from '../../../components/SelectSearch'
import UserSelectSearch from '../../../components/SelectSearch/UserSelectSearch'
import useAxios from '../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../types/pagination'
import { IPipeline } from '../../../types/pipeline'
import { IUserLists } from '../../../types/user'
import { validateMinMaxValue } from '../../../utils/validateMinMaxValue'
import PipelineSelectSearch from '../../../components/SelectSearch/PipelineSelectSearch'
import { ONLY_DATE_TIME_FORMAT } from '../../../constants/global'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

interface IMoveLeadFormModalProps {
  isOpen: boolean
  onClose: (visible: boolean) => void
  onSuccess: (data: IImportByOrdersForm) => void
}

export interface IImportByOrdersForm {
  expiredDays: number
  pipelineObjectId: string
  assignToObjectId?: string
  date?: string
}

const getImportFormValidationSchema = () => {
  return Yup.object({
    expiredDays: Yup.number()
      .min(1, 'กรุณากรอกจำนวนวันที่หมดอายุมากกว่า 1 วัน')
      .max(1000, 'กรุณากรอกจำนวนวันที่หมดอายุน้อยกว่า 1000 วัน')
      .required('กรุณากรอกจำนวนวันที่หมดอายุ'),
    pipelineObjectId: Yup.string().required('กรุณาเลือกท่อ'),
    assignToObjectId: Yup.string(),
  })
}

export const OrderImportLeadFormModal = (props: IMoveLeadFormModalProps) => {
  const { isOpen, onClose, onSuccess } = props
  const [searchUserTelesales, setSearchUserTelesales] = useState<string>('')
  const [searchPipeline, setSearchPipeline] = useState<string>('')
  const [isLoading, setIsLoading] = useState(false)

  const userTelesalesList = useAxios<PaginationResponseInterface<IUserLists>>({
    method: 'GET',
    url: '/users/merchant',
    params: {
      page: 1,
      perPage: 5,
      search: searchUserTelesales,
      startDate: '',
      endDate: '',
    },
  })
  const handleSearchUserTelesales = async (value: string) => {
    setSearchUserTelesales(value)
    await userTelesalesList.mutate()
  }

  const pipelineList = useAxios<PaginationResponseInterface<IPipeline>>({
    method: 'GET',
    url: '/pipeline',
    params: {
      page: 1,
      perPage: 5,
      search: searchPipeline,
      startDate: '',
      endDate: '',
    },
  })
  const handleSearchPipeline = async (value: string) => {
    setSearchPipeline(value)
    await pipelineList.mutate()
  }

  const formik = useFormik<IImportByOrdersForm>({
    initialValues: {
      expiredDays: 1,
      pipelineObjectId: '',
      assignToObjectId: '',
    } as IImportByOrdersForm,
    validationSchema: getImportFormValidationSchema(),
    onSubmit: async (values: IImportByOrdersForm) => {
      setIsLoading(true)
      onSuccess(values)
      setIsLoading(false)
    },
  })

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="lg">
      <CircularLoading isLoading={isLoading} />
      <DialogTitle>ย้าย Pipeline</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={6}>
              {/* <SelectSearch<IPipeline>
                label={'เลือก pipeline'}
                onSelect={(e) =>
                  formik.setFieldValue('pipelineObjectId', e?.value.objectId)
                }
                search={searchPipeline}
                onSearch={handleSearchPipeline}
                options={
                  pipelineList.data?.records.map((pipeline: IPipeline) => ({
                    label: pipeline.name,
                    value: pipeline,
                  })) || ([] as IOptionSelect<IPipeline>[])
                }
                name="pipelineObjectId"
                helperText={
                  formik.touched.pipelineObjectId &&
                  (formik.errors.pipelineObjectId as string)
                }
                error={
                  !!(
                    formik.touched.pipelineObjectId &&
                    formik.errors.pipelineObjectId
                  )
                }
                onBlur={formik.handleBlur}
              /> */}
              <PipelineSelectSearch
                multiple={false}
                label={'เลือก pipeline'}
                onSelect={(e) =>
                  formik.setFieldValue('pipelineObjectId', e?.value.objectId)
                }
                name="pipelineObjectId"
                helperText={
                  formik.touched.pipelineObjectId &&
                  (formik.errors.pipelineObjectId as string)
                }
                error={
                  !!(
                    formik.touched.pipelineObjectId &&
                    formik.errors.pipelineObjectId
                  )
                }
                onBlur={formik.handleBlur}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              {/* <SelectSearch<IUserLists>
                label={'กำหนดผู้ดูแล Lead'}
                onSelect={(e) =>
                  formik.setFieldValue('assignToObjectId', e?.value.objectId)
                }
                search={searchUserTelesales}
                onSearch={handleSearchUserTelesales}
                options={
                  userTelesalesList.data?.records
                    .filter(
                      (userTelesales: IUserLists) => userTelesales.isAvailable,
                    )
                    .map((userTelesales: IUserLists) => ({
                      label: userTelesales.name,
                      value: userTelesales,
                    })) || ([] as IOptionSelect<IUserLists>[])
                }
                name="assignToObjectId"
                helperText={
                  formik.touched.assignToObjectId &&
                  (formik.errors.assignToObjectId as string)
                }
                error={
                  !!(
                    formik.touched.assignToObjectId &&
                    formik.errors.assignToObjectId
                  )
                }
                onBlur={formik.handleBlur}
              /> */}

              <UserSelectSearch
                label={'กำหนดผู้ดูแล Lead'}
                onSelect={(e) =>
                  formik.setFieldValue('assignToObjectId', e?.value.objectId)
                }
                name="assignToObjectId"
                helperText={
                  formik.touched.assignToObjectId &&
                  (formik.errors.assignToObjectId as string)
                }
                error={
                  !!(
                    formik.touched.assignToObjectId &&
                    formik.errors.assignToObjectId
                  )
                }
                onBlur={formik.handleBlur}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                fullWidth
                id="expiredDays"
                label="จำนวนวันที่หมดอายุ (วัน)"
                name="expiredDays"
                value={formik.values.expiredDays}
                onBlur={formik.handleBlur}
                type={'number'}
                onKeyPress={(e) => {
                  if (['+', '-', 'e', '*', '.'].includes(e.key)) {
                    e.preventDefault()
                  }
                }}
                onChange={(e) =>
                  formik.setFieldValue(
                    'expiredDays',
                    validateMinMaxValue(e.target.value, 0, 1000) || '',
                  )
                }
                helperText={
                  formik.touched.expiredDays &&
                  (formik.errors.expiredDays as string)
                }
                error={
                  !!(formik.touched.expiredDays && formik.errors.expiredDays)
                }
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  disablePast
                  format={ONLY_DATE_TIME_FORMAT}
                  ampm={false}
                  label="เลือกวันที่ติดตาม"
                  name="date"
                  sx={{ width: '100%' }}
                  onChange={(e) => formik.setFieldValue('date', e)}
                  slotProps={{
                    textField: {
                      helperText: '',
                      error: false,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                startIcon={<SaveIcon />}
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                ย้าย Lead
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose(false)}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
